import React from 'react';
import { PersonalDetails } from './PersonalDetails';
import ReactLoading from 'react-loading';
import { useAlert } from 'react-alert';

export const PersonalDetailsPage = props => {
    const [hideButton, setHideButton] = React.useState(false);            
    //Sets the loading state
    const [notLoading, setNotLoading] = React.useState(true);

    //Sets invalid phone and email field
    const [invalidPhone, setInvalidPhone] = React.useState(true);
    const [invalidEmail, setInvalidEmail] = React.useState(true);
    const [invalidHomePhone, setInvalidHomePhone] = React.useState(true);

    /*                       STATES START                            */

    //Sets the response data and whether the postal is same as residential
    const [responseData, setResponseData] = React.useState('');
    const [sameAddress, setSameAddress] = React.useState(false);

    //List of occupations
    const [occupations, setOccupations] = React.useState([]);

    //Sets the dropdown menu for the suggested addresss
    const [items, setItems] = React.useState([]);
    const [postalItems, setPostalItems] = React.useState([]);

    //Stores the return address results from the API
    const [results, setResults] = React.useState([]);
    const [postalResults, setPostalResults] = React.useState([]);

    //Handles the hidden state of the address select box
    const [noAddressOptions, setNoAddressOptions] = React.useState(true);
    const [noPostalOptions, setNoPostalOptions] = React.useState(true);

    //Disables the textboxes if the user is viewing the component form a signup page
    const [notSignUp, setNotSignUp] = React.useState(true);
    const [disableMobile, setDisableMobile] = React.useState(false);


    /*                       STATES END                            */

    /*                       USEEFFECT START                            */
    
    //Gets the member details from the API and sets the forms default values
    React.useEffect(() => {
        if('parentIFrame' in window){
            window.parentIFrame.scrollTo(0, 0);
        }

        if(window.location.pathname !== '/details'){
            setHideButton(true);
        }

        //Fetch and set the occupations array
        fetch(localStorage.getItem('server') + 'occupations')
        .then(function(resp){
            return resp.json();
        })
        .then(function(data){
            setOccupations(data.data);
        });
        
        //isedited is used for the renew page. it will detect when the user has moved to the next step, and if the user go back to the 
        //person details step, then it will load the data that the user has entered instead of retrieving data from the database
        // console.log(props.isEdited);

        //If isEdited is false, then it will pull data from the database
        if(window.location.pathname.includes('signup') && !props.isEdited){
            //Enable mobile phone field if referral code is provided
            if(props.referralCode){
                setDisableMobile(false);
            } else {
                setDisableMobile(true);
            }
            setNotSignUp(false);
            setNotLoading(true);
        } else if(!props.isEdited){
            if(window.location.pathname.includes('renew')){
                setInvalidEmail(props.invalidEmail);
                setInvalidPhone(props.invalidPhone);
                setInvalidHomePhone(props.invalidHomePhone);
            }
            setNotLoading(false);
            fetch(localStorage.getItem('server') + 'member', {
                method: 'GET',
                headers: {
                    token: sessionStorage.getItem('token'),
                    memberNumber: sessionStorage.getItem('memberNumber')
                }
            })
            .then(function(resp){
                return resp.json();
            })
            .then(function(data){
                setNotLoading(true);
                if(data.status === 401){
                    // console.log("Invalid Token - Redirecting to login");
                    // props.history.push("");
                    // window.location.replace(window.location.origin);
                    alert.show(
                        <span ref={sessionRef}>
                            Your session has expired. Please login to continue.
                        </span>
                        , {
                            title: "Session Expired"
                    });
                } else if(data.status === 429){
                    alert.show(
                        <span ref={sessionRef}>
                            Too many requests. Please try again later.
                        </span>
                        , {
                            title: "Uh Oh..."
                    });
                } else {
                    if(data.addresses.length === 0){
                        data.member.residentialAddress = data.member.addr1 + ', ' + data.member.city + ' ' + data.member.state + ' ' + data.member.zip;
                        data.member.defaultPostalAddress = data.member.addr1 + ', ' + data.member.city + ' ' + data.member.state + ' ' + data.member.zip;
                        getInital(data.member.defaultPostalAddress, true, 1);
                        getInital(data.member.residentialAddress, true, 2);
                        setSameAddress(true);
                    } else {
                        data.member.residentialAddress = data.addresses[0].addr1 + ', ' + data.addresses[0].city + ' ' + data.addresses[0].state + ' ' + data.addresses[0].zip;
                        data.member.defaultPostalAddress = data.member.addr1 + ', ' + data.member.city + ' ' + data.member.state + ' ' + data.member.zip;
                        getInital(data.member.defaultPostalAddress, true, 1);
                        getInital(data.member.residentialAddress, true, 2);
                        setSameAddress(false);
                    }
                    setResponseData(data.member);
                }
            })
        } else {
            if(window.location.pathname.includes('signup')){
                setDisableMobile(true);
                setNotSignUp(false);
            }
            //set the else statement to pull data from what the user has saved instead of the database here
            // console.log("Welcome Back");
            // console.log(props.detailsData);
            setResponseData(props.detailsData);
            setInvalidEmail(props.invalidEmail);
            setInvalidPhone(props.invalidPhone);
            setInvalidHomePhone(props.invalidHomePhone);
            if(props.detailsData.defaultPostalAddress === props.detailsData.residentialAddress){
                // console.log("They are the same");
                setSameAddress(true);
            } else {
                // console.log("THey are not the same");
                setSameAddress(false);
            }
            // setSameAddress(props.detailsData.sameAsResidental);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.invalidHomePhone]);

    //Returns the validated address options
    function getInital(address, invisible, id){
        var addressQuery = address.replace(/\s/g, '%20');
        fetch(localStorage.getItem('server') + 'api/app/addressr?query=' + addressQuery, {
            method: 'GET'
        })
        .then(function(resp){
            return resp.json();
        })
        .then(function(data){
            //If it returns an address, populate the select list
            if(data.addresses.count > 0){
                var addressArray = [];
                var resultsArray = [];
                data.addresses.forEach(function(result){
                    addressArray.push(result.sla);
                    resultsArray.push(result);
                });

                if(id === 1){
                    setPostalItems(addressArray);
                    setPostalResults(resultsArray);
                    setNoPostalOptions(invisible);
                } else {
                    setItems(addressArray);
                    setResults(resultsArray);
                    setNoAddressOptions(invisible);
                }
            } else {
                if(id === 1){
                    setNoPostalOptions(true);
                } else {
                    setNoAddressOptions(true);
                }
            }
        })
    }

    const redirectHome = () =>{
        props.history.push('/home')
    }

    // React.useEffect(() => {

    //     if(props.responseData){
    //         setResponseData(props.responseData);
    //     }

    // },[props.responseData])

    const handleClick = (formDetails, memberID) => {
        setNotLoading(false);
        // console.log("SAVING DATA");

        fetch(localStorage.getItem('server') + 'member', {
            method: 'POST',
            body: JSON.stringify(formDetails),
            headers: {
                token: sessionStorage.getItem('token'),
                memberNumber: sessionStorage.getItem('memberNumber')
            }
        })
        .then(function(resp){
            return resp.json();
        })
        .then(function(data){
            setNotLoading(true);
            if(data.status === 401){
                // console.log("Invalid Token - Redirecting to login");
                // props.history.push("");
                alert.show(
                    <span ref={sessionRef}>
                        Your session has expired. Please login to continue.
                    </span>
                    , {
                        title: "Session Expired"
                });
            } else if(data.status === 429){
                alert.show(
                    <span>
                        To many requests. Please try again later.
                    </span>
                    , {
                        title: "Uh Oh..."
                    }
                )
            } else {

                if(data.success){
                    // console.log("Successfully updated. Redirecting");
                    // redirectHome();
                    props.history.push({
                        pathname: '/home',
                        saveDetails: true
                    });
                } else {
                    //Sets the invalid field icons
                    setInvalidPhone(true);
                    setInvalidEmail(true);
                    setInvalidHomePhone(true);
                    data.invalidFields.forEach(function(field){
                        switch(field){
                            case 'email':
                                setInvalidEmail(false);
                                break;
                            case 'mobile': 
                                setInvalidPhone(false);
                                break;
                            case 'homePhone':
                                setInvalidHomePhone(false);
                                break;
                            default:
                                break;
                        }
                    });
                }
            }
        });
    }

    const alert = useAlert();

    const saveData = (formData) =>{
        props.saveDetails(formData);
    }

    //Handles the redirect of expired sessions
    const sessionRef = (node)=>{
        if(node === null){
            window.location.replace(window.location.origin);
        }
    }


    return(
        <div>
            <div className="overlay" hidden={notLoading}>
                <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
            </div>
            <div className="container content">
            {notSignUp ? <h2 className="text-center" ><strong>Personal Details</strong></h2> : <h2 className="text-center" ><strong>Sign Up</strong></h2>}
            <p className="text-justify" hidden={!notSignUp}>Some of your personal details are required by law and cannot be edited on this portal. For any changes to your name please visit Bankstown Sports Reception or any of our associated venues with relevant documentation.</p>
            <p className="text-justify" hidden={notSignUp}></p>
            </div> 
            <PersonalDetails disableMobile={disableMobile} notSignUp={notSignUp} saveData={saveData} isEdited={props.isEdited} redirectHome={redirectHome} submit={handleClick} invalidEmail={invalidEmail} invalidPhone={invalidPhone} invalidHomePhone={invalidHomePhone} responseData={responseData} sameAddress={sameAddress} items={items} postalItems={postalItems} results={results} postalResults={postalResults} noAddressOptions={noAddressOptions} noPostalOptions={noPostalOptions} hideButton={hideButton} occupations={occupations} clubID={props.clubID} mobileNumber={props.mobileNumber} />
        </div>
    );
}